module.exports = "pegasus/assets/blocks/column-17-theme4.png";